import { render, staticRenderFns } from "./ConsentOptinUpdatePage.vue?vue&type=template&id=6b1e15b2&scoped=true&"
import script from "./ConsentOptinUpdatePage.vue?vue&type=script&lang=js&"
export * from "./ConsentOptinUpdatePage.vue?vue&type=script&lang=js&"
import style0 from "./ConsentOptinUpdatePage.vue?vue&type=style&index=0&id=6b1e15b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1e15b2",
  null
  
)

export default component.exports